import './featured-list.scss';

import { Component, Vue } from 'vue-property-decorator';

import { Featured, FeaturedCard } from '../featured-card';
import { DELETE_CARD } from '@skinsoft/events';

@Component({
    components: {
        sFeaturedCard: FeaturedCard,
    },
    props: ['emptyMessage', 'featureds', 'title', 'customCard', 'customCardProps'],
    template: require('./featured-list.html'),
})
export class FeaturedList extends Vue {
    public emptyMessage: string;
    public featureds: Featured[];
    public title: string;
    public customCard: Vue.Component
    public customCardProps: Object

    private DELETE_CARD = DELETE_CARD
}
